import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { POSTHOG_API_HOST, POSTHOG_TOKEN } from './config/global';
import { POSTHOG_FEATURE_FLAGS } from './config/postHog';

/**
 * @type {Partial<import('posthog-js').PostHogConfig>}
 */
const postHogOptions = {
  api_host: POSTHOG_API_HOST,
  autocapture: false,
  loaded: (loadedInstance) => {
    loadedInstance.onFeatureFlags(() => {
      if (loadedInstance.isFeatureEnabled(POSTHOG_FEATURE_FLAGS.ENABLE_AUTOCAPTURE)) {
        loadedInstance.config.autocapture = true;
      }
    });
  },
};

function PostHogContextWrapper({ children }) {
  if (!POSTHOG_TOKEN) {
    return children;
  }

  return (
    <PostHogProvider apiKey={POSTHOG_TOKEN} options={postHogOptions}>
      {children}
    </PostHogProvider>
  );
}

export default PostHogContextWrapper;
